<template>
    <div style="height: 100%">
        <div class="sa-flexbox" style="padding-bottom: 20px">
            <div class="sa-flexbox-header">
                <!-- <b-form @submit.prevent="onSubmit">
          <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
          </b-row>
        </b-form> -->
            </div>
            <div class="sa-flexbox-body">
                <div class="b-table-sticky-header">
                    <span class="sa-flexbox-body-title">Impegnative</span>
                    <b-button size="sm" variant="outline-success outline-primary-noborder sa-margin-right float-sm-right" @click="nuovaImpegnativa" class="mb-2" v-if="!isViewMode">
                        <font-awesome-icon icon="plus"> </font-awesome-icon>
                        Aggiungi
                    </b-button>
                    <b-button size="sm" variant="outline-purple outline-primary-noborder  sa-margin-right float-sm-right" @click="onClickStampaListaImpegnativa()">
                        <b-icon icon="printer" />
                        Stampa
                    </b-button>
                    <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
                        <template v-slot:cell(tipoImpegnativa)="{ item }">
                            {{ item.impegnativaTipo || item.tipoImpegnativa }}
                        </template>

                        <template v-slot:cell(trattamentoDataInizio)="{ item }">
                            <span>{{ formatDate(item.trattamentoDataInizio) }}</span>
                        </template>
                        <template v-slot:cell(trattamentoDataFine)="{ item }">
                            <span>{{ formatDate(item.trattamentoDataFine) }}</span>
                        </template>
                        <template v-slot:cell(quote)="{ item }">
                            <span class="sa-table-span-label-primary">Quota Totale: {{ item.quotaTotale }} €</span>
                            <span class="sa-table-span-label-primary">Quota ASL: {{ item.quotaAsl }} € ({{ item.quotaAslPercentuale }}%)</span>
                            <span class="sa-table-span-label-primary"> Quota Comune: {{ item.quotaComune }} € ({{ item.quotaComunePercentuale }}%)</span>
                            <span class="sa-table-span-label-primary">Quota Utente: {{ item.quotaUtente }} € ({{ item.quotaUtentePercentuale }}%)</span>
                        </template>
                        <template v-slot:cell(actions)="{ item }">
                            <b-container class="bv-example-row" v-if="!isViewMode">
                                <print-component :documentRepository="true" :idRisorsa="item.id" :typeButton="'small'"> </print-component>
                                <b-button size="sm" v-b-tooltip.hover title="Visualizza Allegati" variant="outline-success no-text" @click="onClickVisualizzaAllegati(item)">
                                    <b-icon icon="file-earmark-plus" aria-hidden="true"></b-icon>
                                </b-button>
                                <b-button size="sm" v-b-tooltip.hover title="Duplica Impegnativa" variant="outline-success no-text" @click="onDuplicaImpegnativa(item)">
                                    <font-awesome-icon icon="copy"> </font-awesome-icon>
                                </b-button>
                                <b-button size="sm" v-b-tooltip.hover title="Modifica Impegnativa" variant="outline-success" @click="onEditImpegnativa(item)">
                                    <font-awesome-icon icon="edit"></font-awesome-icon>
                                </b-button>

                                <b-button size="sm" v-b-tooltip.hover title="Cancella Impegnativa" variant="outline-danger" @click="onDeleteImpegnativa(item)">
                                    <font-awesome-icon icon="trash"></font-awesome-icon>
                                </b-button>
                            </b-container>
                        </template>
                    </b-table>
                </div>
            </div>
            <div class="sa-flexbox-footer" style="background-color: ciano">
                <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col lg="3">
                        <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
                    </b-col>
                    <b-col lg="9">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                    </b-col>
                </b-row>
            </div>
            <rsa-accettazione-impegnativa-edit-component ref="cmpRsaAccettazioneImpegnativaEditComponent" :idAccettazione="idAccettazione" :jsonDataAccettazione="jsonData" @afterSaveRequest="onAfterSaveRequestRsaImpegnativaComponent"></rsa-accettazione-impegnativa-edit-component>
            <b-modal ref="mdlListaAllegati" id="mdlListaAllegati" size="xl" style="height: 100%" no-close-on-backdrop no-close-on-esc hide-header-close>
                <allegato-model-component v-if="modalStep === 0" :idRisorsa="recordSelezionato.id" @updateFiles="onUpdateFile()" :jsonData="recordSelezionato" tipoDocumento="IMPEGNATIVA"></allegato-model-component>
                <paziente-allegati-edit-component v-if="modalStep === 1" :jsonData="data" :tipoRisorsa="'IMPEGNATIVA'"></paziente-allegati-edit-component>
                <template #modal-footer>
                    <b-button v-if="modalStep === 1" size="md" class="no-text" variant="outline-danger" @click="onClickUndo">Annulla</b-button>
                    <b-button v-if="modalStep === 1" @click="onSalvaRichiesta" :disabled="modalStep !== 1" variant="outline-success">Salva</b-button>
                    <b-button v-if="modalStep === 0" @click="onClickAddAllegati" variant="outline-success">Aggiungi</b-button>
                    <b-button v-if="modalStep === 0" @click="onClickOk" variant="outline-primary">Chiudi</b-button>
                </template>
            </b-modal>
        </div>
        <!--<print-component v-show="false" ref="cmpPrint"></print-component>>-->
        <modal-error ref="cmpModalError"></modal-error>
    </div>
</template>
<script>
import axios from "axios";
import UtilityMixin from "../../../utility/UtilityMixin";
import RsaAccettazioneImpegnativaEditComponent from "./RsaAccettazioneImpegnativaEditComponent.vue";
import AllegatoModelComponent from "../../../utility/components/AllegatoModelComponent.vue";
import PazienteAllegatiEditComponent from "../../../paziente/allegati/components/PazienteAllegatiEditComponent.vue";
import PrintComponent from "../../../utility/components/PrintComponent.vue";
import ModalError from "../../../../template/components/modal/components/ModalError.vue";
export default {
    props: {
        jsonData: { type: Object },
        idAccettazione: { type: String },
        isViewMode: { type: Boolean },
    },
    mixins: [UtilityMixin],
    components: {
        RsaAccettazioneImpegnativaEditComponent,
        AllegatoModelComponent,
        PazienteAllegatiEditComponent,
        PrintComponent,
        ModalError,
        // DatePicker,
    },
    data() {
        return {
            rows: 0,
            perPage: 50,
            currentPage: 1,
            isNew: false,
            filtro: {},
            items: [],
            data: { dataCaricamento: new Date().getTime(), idAnagrafica: null, idRisorsa: null },
            listKey: 0,
            childKey: 0,
            pathResource: "/rsaimpegnativa",
            pathResourceAllegati: "/allegati",
            recordSelezionato: {},
            modalStep: 0,
            linkedit: "/",
            fields: [
                {
                    label: "Tipo Impegnativa",
                    key: "tipoImpegnativa",
                },
                {
                    label: "Onere Prestazione",
                    key: "onerePrestazione",
                },
                {
                    label: "Data Inizio del Trattamento",
                    key: "trattamentoDataInizio",
                },
                {
                    label: "Data fine del Trattamento",
                    key: "trattamentoDataFine",
                },
                // {
                //   label: "Numero Giorni del Trattamento",
                //   key: "numeroGiorniTrattamento",
                // },
                { label: "Quote", key: "quote" },
                { class: "sa-table-column-action-double", key: "actions", label: "" /* thStyle: () => (this.isViewMode ? "display: none" : "") */ },
            ],
        };
    },
    mounted() {
        //let me = this;
        //  me.idAccettazione = me.$route.params.id;
        // me.loadData();
    },
    watch: {
        currentPage() {
            let me = this;
            me.loadData();
        },
    },
    methods: {
        onUpdateFile() {
            let me = this;
            me.childKey++;
        },
        onClickUndo() {
            let me = this;
            // me.$refs.mdlAllegatiList.loadData();
            me.modalStep = 0;
        },
        onSalvaRichiesta() {
            let me = this;
            let obj = me.getDataPdf(me.data);
            let link = process.env.VUE_APP_PATH_API + me.pathResourceAllegati;
            me.showModalLoading = true;
            axios
                .post(link, obj)
                .then(() => {
                    me.modalStep = 0;
                    me.showModalLoading = false;
                    // me.$refs.mdlAllegatiList.loadData();
                    me.$emit("updateFiles");
                    this.$bvToast.toast(`${this.getLabelTraduora("patient.afa.lblToastSuccessUpload")} - ${this.data.nomeFile}`, {
                        title: "File Upload",
                        autoHideDelay: 2000,
                        variant: "success",
                    });
                })
                .catch((error) => {
                    let message = "";
                    error.response ? error.response.data.messaggio : "Errore non gestito";
                    if (error.response) {
                        message = error.response.data.messaggio ? error.response.data.messaggio : "Codice Errore: " + error.response.status + ", non gestito";
                    }
                    if (error.response) {
                        this.$bvModal
                            .msgBoxOk(message, {
                                title: "ATTENZIONE",
                                size: "sm",
                                okVariant: "outline-danger",
                                headerClass: "sa-msg-header-danger",
                                footerClass: "p-2 border-top-0",
                                centered: true,
                            })
                            .then(() => {})
                            .catch((err) => {
                                console.log(err);
                            });
                    }
                });
        },
        getDataPdf(obj) {
            // let me = this;
            let objPdf = {};
            objPdf.idRisorsa = obj.idRisorsa;
            objPdf.idAnagrafica = obj.idAnagrafica;
            objPdf.nomeFile = obj.nomeFile;
            objPdf.size = obj.size;
            objPdf.file = obj.file;
            objPdf.tipo = obj.tipo;
            objPdf.dataCaricamento = obj.dataCaricamento;
            objPdf.descrizione = obj.descrizione;
            objPdf.tipoDocumento = obj.tipoDocumento;
            return objPdf;
        },
        onClickAddAllegati() {
            let me = this;
            me.modalStep = 1;
        },
        onClickOk() {
            let me = this;
            me.modalStep = 0;
            me.$refs.mdlListaAllegati.hide();
        },
        loadData() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            if (sessionStorage["filtro"]) {
                me.filtro = JSON.parse(sessionStorage["filtro"]);
            }
            let link = process.env.VUE_APP_PATH_API + me.pathResource;
            me.filtro.page = me.currentPage;
            me.filtro.forPage = me.perPage;
            me.filtro.idAccettazione = me.idAccettazione;
            me.$emit("beforeLoadData");
            axios
                .get(link, { params: me.filtro })
                .then((response) => {
                    me.items = [];
                    me.rows = response.data.data.recordsNumber;
                    me.items = response.data.data.list;
                    me.listKey++;
                    this.$emit("afterLoadData");
                })

                .catch(() => {
                    this.$emit("afterLoadData");
                });
        },
        nuovaImpegnativa() {
            let me = this;
            /* me.isNew = true; */
            if (me.jsonData.statoAttuale === "DIMESSO" || me.jsonData.statoAttuale === "TRASFERITO" || me.jsonData.statoAttuale === "ASSENTE") {
                let messaggio = me.jsonData.statoAttuale === "DIMESSO" || me.jsonData.statoAttuale === "TRASFERITO" ? "Non è possibile questa operazione su un paziente dimesso" : "Non è possibile questa operazione su un paziente assente";
                me.$bvModal.msgBoxOk(messaggio, {
                    title: "ATTENZIONE",
                    size: "sm",
                    okVariant: "outline-danger",
                    headerClass: "sa-msg-header-danger",
                    footerClass: "p-2 border-top-0",
                    centered: true,
                });
                return;
            } else
                me.$refs.cmpRsaAccettazioneImpegnativaEditComponent.show({
                    codiceAsl: "",
                    codiceDistretto: "",
                    dataAutorizzazione: null,
                    dataPrescrizione: "",
                    descrizioneAsl: "",
                    descrizioneDistretto: "",
                    diagnosiIcdixCodice: "",
                    diagnosiIcdixDescrizione: "",
                    idAccettazione: "",
                    medicoPrescrittoreCodice: "",
                    medicoPrescrittoreTipo: "",
                    note: "",
                    numeroAutorizzazione: "",
                    numeroGiorniTrattamento: null,
                    onerePrestazione: "",
                    quotaTotale: "",
                    quotaAsl: "",
                    quotaAslPercentuale: "",
                    quotaComune: "",
                    quotaComunePercentuale: "",
                    quotaUtente: "",
                    quotaUtentePercentuale: "",
                    statoAttuale: null,
                    statoAttualeDataOra: "",
                    tipoImpegnativa: "",
                    tipoPrestazione: null,
                    trattamentoDataFine: "",
                    trattamentoDataInizio: new Date().getTime(),
                    trattamentoTipo: "",
                });
            me.$refs.cmpRsaAccettazioneImpegnativaEditComponent.setData();
        },
        // onSalvaImpegnativa() {
        //   let me = this;
        //   me.$refs.RsaAccettazioneImpegnativaEditComponent.salvaImpegnativa();
        // },

        onEditImpegnativa(item) {
            let me = this;
            me.$refs.cmpRsaAccettazioneImpegnativaEditComponent.loadData(item.id);
            me.$refs.cmpRsaAccettazioneImpegnativaEditComponent.show(item);
        },
        onDeleteImpegnativa(item) {
            let me = this;
            this.$bvModal
                .msgBoxConfirm("Sicuro di voler procedere alla cancellazione?", {
                    title: "Eliminazione Ricetta",
                    buttonSize: "sm",
                    okVariant: "secondary",
                    cancelVariant: "danger",
                    okTitle: "SI",
                    cancelTitle: "NO",
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        me.deleteImpegnativa(item.id);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        deleteImpegnativa(id) {
            let me = this;
            me.showModalLoading = true;
            let link = process.env.VUE_APP_PATH_API + me.pathResource + "/" + id;
            axios
                .delete(link)
                .then((Response) => {
                    console.log(Response);

                    me.showModalLoading = false;
                    me.loadData();
                })
                .catch((e) => {
                    console.log(e);
                });
        },
        onDuplicaImpegnativa(item) {
            let me = this;
            /*  item.primaryKey = null;
            item.id = null;
            item.trattamentoDataInizio = null;
            item.trattamentoDataFine = null;
            item.dataPrescrizione = null;
            item.numeroGiorniTrattamento = null;
            item.dataAutorizzazione = null; */
            me.loadDataResources(me.pathResource + "/duplica/" + item.id, {}, me.resultResponseDuplica, me.resultErrorDuplica);
            //me.$refs.cmpRsaAccettazioneImpegnativaEditComponent.show(item);
        },
        resultResponseDuplica(response) {
            let me = this;
            let impegnativaDuplicata = response.data.data;
            impegnativaDuplicata.numeroAutorizzazione = null;
            me.$refs.cmpRsaAccettazioneImpegnativaEditComponent.show(impegnativaDuplicata);
        },
        resultErrorDuplica(error) {
            let messaggio = error.response.messaggio ? error.response.messaggio : "Impegnativa non trovata";
            this.$bvToast.toast(messaggio, {
                title: "Impegnativa",
                solid: true,
                variant: "danger",
                autoHideDelay: 5000,
                appendToast: true,
            });
        },
        onAfterSaveRequestRsaImpegnativaComponent() {
            let me = this;
            me.$refs.cmpRsaAccettazioneImpegnativaEditComponent.close();
            this.$bvToast.toast(`Richiesta salvata correttamente`, {
                title: "Impegnativa",
                solid: true,
                variant: "success",
                autoHideDelay: 5000,
                appendToast: true,
            });
            me.loadData();
        },
        onClickVisualizzaAllegati(item) {
            let me = this;
            me.recordSelezionato = item;
            me.data.idRisorsa = item.id;
            me.data.idAnagrafica = item.idAccettazione;
            me.$refs.mdlListaAllegati.show();
            // me.$refs.mdlAllegatiList.loadData();
        },

        onClickStampaListaImpegnativa() {
            let me = this;
            me.loadDataResources(me.pathResource + "/printdata/" + me.idAccettazione, { idAccettazione: me.idAccettazione }, me.resulResponseStampaLista, me.resulErrorStampaLista);
        },
        resulResponseStampaLista(response) {
            let me = this;
            me.$refs.cmpPrint.print(response.data.data);
        },
        resulErrorStampaLista(error) {
            let me = this;
            me.$refs.cmpModalError.show(error.response.data.messaggio + "#");
        },
        onClickStampaImpegnativa(item) {
            let me = this;
            me.loadDataResources(me.pathResource + "/printdata/" + item.id, null, me.resulResponseStampaImpegnativa, me.resulErrorStampaImpegnativa);
        },
        resulResponseStampaImpegnativa(response) {
            let me = this;
            me.$refs.cmpPrint.print(response.data.data);
        },
        resulErrorStampaImpegnativa(error) {
            let me = this;
            me.$refs.cmpModalError.show(error.response.data.messaggio + "#");
        },
    },
};
</script>
